/**
 * Человекочитаемое имя сезона для UI.
 *
 * В данных встречаются «сырые» слаги сезонов из миграций/импорта:
 *   "2026_сезон", "2026й сезон", "2025_26", "Сезон 2026" и т.п.
 * UI должен показывать единый формат «Сезон {год}» (AK-298, DS-консистентность).
 *
 * Стратегия:
 *  1. Если передан явный числовой `year` — используем его: «Сезон 2026».
 *  2. Иначе пытаемся вытащить 4-значный год из `code`/`name`.
 *  3. Если в строке диапазон лет ("2025_26", "2025/2026") — берём первый год.
 *  4. Если год не нашёлся — отдаём исходную строку as-is (без поломки UI).
 */
export function formatSeasonName(
  codeOrName?: string | null,
  year?: number | null,
): string {
  if (typeof year === 'number' && Number.isFinite(year) && year > 0) {
    return `Сезон ${year}`;
  }

  const raw = (codeOrName ?? '').trim();
  if (!raw) return '';

  // Первый 4-значный год в строке. НЕ используем \b — в слагах вроде
  // "2026_сезон" символ "_" является word-char, и \b между цифрой и "_"
  // отсутствует. Требуем, чтобы перед годом не было цифры (?<!\d) и после —
  // тоже (?!\d), чтобы не разрезать 6-значные числа пополам.
  const match = /(?<!\d)(\d{4})(?!\d)/.exec(raw);
  if (match) {
    return `Сезон ${match[1]}`;
  }

  // Год не распознан — возвращаем исходную строку (не ломаем UI).
  return raw;
}
